import { APIS } from '@/utilities/constants';
import axiosInstance from '@/services';

export const cartAPI = {
  /**
   *     API service to GET /api/cart/v1/ez/count
   *     private Integer productMaxLimit;
   *     private Integer subscriptionMaxLimit;
   *     private Integer productCount;
   *     private Integer subscriptionCount;
   */
  cartCount: async () => {
    const response = await axiosInstance.get(APIS.CART_COUNT, {
      // Explicitly pass empty data to persist Content-Type as application/json
      data: {},
    });
    return response;
  },
};
